import React, {useEffect, useRef, useState} from 'react';
import styled from "styled-components";
import useZibi from "../../../zibi/UseZibi";
import {api} from "../../../maps/data";
import Paper from "@mui/material/Paper";
import {InvAlertBox, InvAlertInfoData, InvAlertSensorWrapper, LoaderStyled} from "./invCommonStyles";
import {CircularProgress} from "@mui/material";
import SensorWithPlacements from "../../storeShelves/SensorWithPlacements";
import ALERT_MAP from "../../../maps/alertMap";

const WrapperStyled = styled.div`
    display: grid;
    grid-gap: 15px;
    width: 900px;
`;

const ZeroLine = ({getFields, getSensors, placements, eventId}) => {
    const selectedDivRef = useRef(null);

    const [dashboardData, s_dashboardData] = useState([]);
    const [updater, s_updater] = useState(0);

    const [fields] = useZibi('fields');
    const [sensors] = useZibi('sensors');

    useEffect(() => {
        if (eventId && selectedDivRef.current) {
            selectedDivRef.current.scrollIntoView({behavior: 'smooth', block: 'start'});
        }
    }, [eventId, selectedDivRef?.current]);

    useEffect(() => {
        setTimeout(() => {
            s_updater(updater + 1);
        }, 700);
    }, []);

    const getDashboardData = async () => {
        api({
            type: "getAlertsByParams",
            data: {
                statuses: [ALERT_MAP.statuses.ACTIVE],
                eventTypes: [ALERT_MAP.eventMainTypes.SHELF_BOUNCER],
                eventEntitys: [ALERT_MAP.eventEntitys.ALERT],
                eventSubTypes: [ALERT_MAP.eventTypesList.ZERO_LINE],
                limit: 40
            }
        }).then(data => {
            s_dashboardData(data);
            getFields(data);
            getSensors(data, true);
        }).catch(e => {
            console.error(e);
        });
    };

    useEffect(() => {
        getDashboardData();
    }, []);

    return (
        <WrapperStyled>
            <h2>Zero Line</h2>
            {dashboardData.map((item) => {
                const field = fields[item?.data?.fieldId];
                const sensor = sensors[item?.data?.sensorId];

                const isLoading = !field || !sensor;
                const sensorPlacements = placements?.[item?.data?.sensorId] || [];

                const selectedEvent = eventId === item._id;

                return (
                    <Paper elevation={1} key={item._id}>
                        {isLoading && (
                            <LoaderStyled>
                                <CircularProgress/>
                            </LoaderStyled>
                        )}
                        {!isLoading && (
                            <InvAlertBox
                                className={selectedEvent ? "selected" : ""}
                                ref={selectedEvent ? selectedDivRef : null}
                            >
                                <InvAlertInfoData>
                                    <div>
                                        {`Field: ${field?.name}, Sensor: ${sensor?.boardId}`}
                                    </div>
                                </InvAlertInfoData>
                                <InvAlertSensorWrapper>
                                    <SensorWithPlacements
                                        placements={sensorPlacements}
                                        sensor={sensor}
                                    />
                                </InvAlertSensorWrapper>
                            </InvAlertBox>
                        )}
                    </Paper>
                );
            })}
        </WrapperStyled>
    );
};

export default ZeroLine;